<template>
  <div>
    <div v-if="canshow">
      <button v-on:click="gotoEsia">
        Войти через
        <img src="img/gosuslugi.svg" />
      </button>
    </div>
  </div>

</template>

<script>
import {mapState} from "vuex";

export default {
  name: "esia",
  data(){
    return {
      canshow:true
    }
  },
  computed: {
    ...mapState({
      valueVuex: state => state.Form.sendData,
    })
  },
  methods:{
    async getEsiaToken(code) {
      const params = {
        grant_type: 'authorization_code',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        client_id: process.env.VUE_APP_ID_ESIA,
        code,
        client_secret: process.env.VUE_APP_SECRET_ESIA
      }
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/token, ${JSON.stringify(params)}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/token`, { ...params })
        this.$palantir.trackAction(177, `fromESIA - getEsiaToken - ${JSON.stringify(data)}`);
        return data.access_token
      } catch(e) {
        console.log(e)
      }
    },
    async getCpg(access_token) {
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/userinfo, ${JSON.stringify({ headers: { 'Authorization': 'Bearer ' + access_token} })}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/userinfo `, {}, { headers: { 'Authorization': 'Bearer ' + access_token} })
        this.$palantir.trackAction(177, `fromESIA - getCpg - ${JSON.stringify(data)}`);
        return data.info
      } catch(e) {
        console.log(e)
      }
    },
    async saveDadataAddress(refs) {
      const { data } = await this.$myApi.suggestResult(
          refs,
          { 'value': this.valueVuex[refs], 'type': refs })
      if(data.result.suggestions.length > 0) {
        this.$store.dispatch('saveSendData', {
          target: refs + '_DADATA',
          value: data.result.suggestions[0],
        });
        this.$store.dispatch('saveSendData', {
          target: refs,
          value: data.result.suggestions[0].value
        });
      } else {
        this.$palantir.trackAction(176, this.valueVuex[refs]);
      }
    },
    gotoEsia() {
      const permissions = [
        'fullname',
        'birthdate',
        'gender',
        'snils',
        'inn',
        'id_doc',
        'birthplace',
        'email',
        'mobile',
        'addresses',
        'electronic_workbook',
      ]
      const params = {
        client_id: process.env.VUE_APP_ID_ESIA,
        response_type: 'code',
        scope: 'openid',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        provider: 'cpg_oauth',
        permissions: permissions.join('+'),
        purposes: 'CREDIT',
        sysname: 'CREDIT',
        actions: 'ALL_ACTIONS_TO_DATA',
        expire: 26297460,
        state: window.tmpTestValue
      }
      const querySrting = Object.entries(params).
      map(([key, value]) => `${key}=${value}`).
      join('&');

      this.$palantir.trackAction(177, `toESIA - ${process.env.VUE_APP_URL_ESIA}/auth/authorize?${querySrting}`);
      location.href = encodeURI(`${process.env.VUE_APP_URL_ESIA}/auth/authorize?${querySrting}`)
    }
  },
  mounted() {
    // if(window.partner_id === 404) {
    //   this.canshow = true;
    // }
    //Что-то пошло не так с госуслугами, запишем
    if(this.$route.query.error) {
      this.$palantir.trackAction(175, this.$route.query.error_description);
      this.$router.replace({ query: {} })
    }

    if (this.$route.query.code) {
      this.$palantir.trackAction(177, `fromESIA - ${JSON.stringify(this.$route.fullPath)}`);
      const code = this.$route.query.code;
      this.$router.replace({ query: {} });

      this.getEsiaToken(code).then(access_token => {
        this.getCpg(access_token).then(userInfo => {
          this.$store.dispatch('saveEsiaInfo', userInfo);
          this.saveDadataAddress('RESIDENTIAL_ADDRESS');
          this.saveDadataAddress('REGISTRATION_ADDRESS');
          // this.loadFromEsia = true;
          // this.WsScrollTo({id:'zform'});
          this.canshow = false;
          this.$emit('scrollEvent');
        })
      })
    }
  }
}
</script>

<style scoped>
button img{width: 4rem;padding: 0.2rem 0 0 0.6rem;}
@media (min-width: 768px) {
  button img{width: 7rem;padding: 0.3rem 0 0 0.6rem;}
}

</style>